"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTableAdditionRowEditable = void 0;
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const strings_1 = require("../../../../constants/strings");
const codingQuery_1 = require("../../../../queries/codingQuery");
const zustandStore_1 = require("../../../../zustandStore");
const onCreateNewCodingEntry_1 = require("../../../templates/companySettings/coding/codingTableSection/onCreateNewCodingEntry");
const lexico = new lexico_1.default();
const isNewEntryId = ({ codingEntries, entryId, selectedCodingList }) => {
    if (entryId === '') {
        return false;
    }
    const selectedCodingEntries = codingEntries?.find(entry => entry?.code === selectedCodingList.id);
    return !selectedCodingEntries.values.some(({ ID: id }) => id === entryId);
};
const useGetTableAdditionRowEditable = ({ teams }) => {
    const { setCurrentSelectedCodingEntry, setNewCodingEntry, setNewCodingEntryTeams, setNotification } = (0, zustandStore_1.useZustand)();
    const { data: codingLists = [] } = (0, react_query_1.useQuery)((0, codingQuery_1.getCodingListsQuery)({ skipDisabled: true }));
    const { data: codingEntries = [] } = (0, react_query_1.useQuery)((0, codingQuery_1.getCodingListsEntriesQuery)({
        codingLists,
    }));
    const selectedCodingList = (0, zustandStore_1.useZustand)(state => state.codingList.currentCodingListSelected);
    const newCodingEntry = (0, zustandStore_1.useZustand)(state => state.codingEntry.newCodingEntry);
    const newCodingEntryTeams = (0, zustandStore_1.useZustand)(state => state.codingEntry.newCodingEntryTeams);
    const toggleCodingListEntryQuery = (0, codingQuery_1.useToggleCodingListEntryQuery)();
    const saveCodingListEntry = (0, codingQuery_1.useSaveCodingListEntryQuery)();
    const company = (0, zustandStore_1.useZustand)(state => state.company);
    return {
        id: 'editableRow',
        entryId: {
            isDefaultEditableCell: true,
            placeholder: strings_1.companySettingsCodingStrings.UNIQUE_IDENTIFIER_PLACEHOLDER,
            text: newCodingEntry.ID,
            onChange(event) {
                setNewCodingEntry({ ...newCodingEntry, ID: event.target.value });
            },
        },
        entryPath: {
            isDefaultEditableCell: true,
            placeholder: strings_1.companySettingsCodingStrings.CODING_ENTRY_PLACEHOLDER,
            text: newCodingEntry.path,
            onChange(event) {
                setNewCodingEntry({ ...newCodingEntry, path: event.target.value });
            },
        },
        rowActions: {
            tsVariant: 'tsBtnAdd',
            text: lexico.trc('Button', 'Add entry'),
            isDefaultEditableCell: true,
            onClick() {
                if (newCodingEntry.ID === '' || newCodingEntry.path === '') {
                    return;
                }
                if (teams && teams.length > 0) {
                    setNewCodingEntryTeams(teams.map(team => ({
                        teamId: team.id,
                        teamName: team.name,
                        state: true,
                    })));
                }
                if (isNewEntryId({ codingEntries, entryId: newCodingEntry.ID, selectedCodingList })) {
                    (0, onCreateNewCodingEntry_1.onCreateNewCodingEntry)({
                        selectedCodingList,
                        newCodingEntry,
                        saveCodingListEntry,
                        toggleCodingListEntryQuery,
                        newCodingEntryTeams,
                        setNewCodingEntry,
                        setCurrentSelectedCodingEntry,
                        company,
                        setNotification,
                    });
                }
                else {
                    const warningMessage = strings_1.companySettingsCodingStrings.CODING_ENTRY_DUPLICATE_ERROR({
                        entryId: newCodingEntry.ID,
                    });
                    setNotification([
                        {
                            type: strings_1.notificationStrings.WARNING,
                            message: warningMessage,
                        },
                    ]);
                }
                setNewCodingEntry({ ID: '', path: '' });
                setCurrentSelectedCodingEntry({ ID: '', path: '' });
            },
        },
    };
};
exports.useGetTableAdditionRowEditable = useGetTableAdditionRowEditable;
